import { jsxs as f, jsx as t } from "react/jsx-runtime";
import { useContext as u } from "react";
import h from "reactjs-popup";
import x from "classnames";
import { ThemeContext as k } from "../ThemeContext/index.js";
const j = ({
  on: i = ["hover", "focus"],
  control: s,
  parentClass: e,
  phoneTitle: r,
  children: m,
  phoneButtons: l,
  position: c = ["bottom left", "bottom right"],
  className: a,
  offsetX: p = 8,
  offsetY: n = 8
}) => {
  const { viewport: d } = u(k), o = d === "phone";
  return /* @__PURE__ */ f(
    h,
    {
      on: o ? "click" : i,
      className: x(a, "tooltip"),
      trigger: s,
      position: c,
      offsetX: p,
      offsetY: n,
      arrow: !1,
      keepTooltipInside: e ? "." + e : !0,
      modal: o,
      closeOnDocumentClick: !0,
      lockScroll: o,
      children: [
        r && o && /* @__PURE__ */ t("div", { className: "tooltip__title", children: r }),
        /* @__PURE__ */ t("span", { children: m }),
        l && o && /* @__PURE__ */ t("div", { className: "tooltip__buttons", children: l })
      ]
    }
  );
};
export {
  j as default
};
